import { BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

import {
  ABOUT_COMPANY_HISTORY_NAMES,
  LIST_OF_KEY_EVENTS_FIELDS,
} from 'components/BusinessToolForm/Sections/AboutCompany/CompanyHistory/utils/form';
import {
  ABOUT_COMPANY_GENERAL_NAMES,
  LIST_OF_FOUNDERS_FIELDS,
} from 'components/BusinessToolForm/Sections/AboutCompany/GeneralInfo/utils/form';
import {
  ABOUT_COMPANY_MISSION_NAMES,
  GOAL_ROW_NAMES,
} from 'components/BusinessToolForm/Sections/AboutCompany/MissionAndVision/utils/form';
import {
  ABOUT_COMPANY_SWOT_NAMES,
  SWOT_ROW_NAMES,
} from 'components/BusinessToolForm/Sections/AboutCompany/SWOT/utils/form';

import { ul } from '../helpers';

const SOCIAL_NETWORKS_INSTRUCTION_TEXT =
  'Перелічіть соціальні мережі, які використовує ваша компанія, разом із відповідними посиланнями. Переконайтеся, що всі посилання коректні та ведуть на ваші офіційні профілі.';
const FOUNDERS_INSTRUCTION_TEXT =
  'Надайте повний перелік засновників вашої компанії. Укажіть їхні повні імена та частку володіння кожного засновника.';

const LIST_OF_FOUNDERS_INSTRUCTIONS = {
  [LIST_OF_FOUNDERS_FIELDS.FIRST_NAME]: {
    name: "Список засновників",
    instruction: FOUNDERS_INSTRUCTION_TEXT,
    exampleOne: '',
    exampleTwo: '',
  },
  [LIST_OF_FOUNDERS_FIELDS.LAST_NAME]: {
    name: 'Список засновників',
    instruction: FOUNDERS_INSTRUCTION_TEXT,
    exampleOne: '',
    exampleTwo: '',
  },
  [LIST_OF_FOUNDERS_FIELDS.SHARE_IN_COMPANY]: {
    name: 'Список засновників',
    instruction: FOUNDERS_INSTRUCTION_TEXT,
    exampleOne: '',
    exampleTwo: '',
  },
};

const GENERAL_INFO_INSTRUCTIONS = {
  [ABOUT_COMPANY_GENERAL_NAMES.LEGAL_STRUCTURE]: {
    name: 'Правова форма',
    instruction:
      'Укажіть правову форму вашої компанії. Серед варіантів: одноосібне володіння, партнерство, корпорація або товариство з обмеженою відповідальністю (ТОВ).',
    exampleOne: 'Товариство з обмеженою відповідальністю',
    exampleTwo: 'Одноосібне володіння',
  },
  [ABOUT_COMPANY_GENERAL_NAMES.WEBSITE_URL]: {
    name: 'Вебсайт',
    instruction: 'Укажіть повну вебадресу вашої компанії.',
    exampleOne: 'agrotech.com',
    exampleTwo: 'languagelab.com',
  },
  [ABOUT_COMPANY_GENERAL_NAMES.PHONE]: {
    name: 'Телефон',
    instruction:
      'Надайте контактний номер телефону компанії, включно з кодом міста/країни.',
    exampleOne: '+1 484 111 11 11',
    exampleTwo: '+1 584 741 21 82',
  },
  [ABOUT_COMPANY_GENERAL_NAMES.EMAIL]: {
    name: 'E-mail',
    instruction:
      'Точно вкажіть офіційну електронну адресу компанії, включно з доменом та, за потреби, відповідним відділом або контактною особою.',
    exampleOne: 'info@agrotech.com',
    exampleTwo: 'info@languagelab.com',
  },
  [ABOUT_COMPANY_GENERAL_NAMES.FACEBOOK]: {
    name: 'Facebook',
    instruction: SOCIAL_NETWORKS_INSTRUCTION_TEXT,
    exampleOne: 'www.facebook.com/agrotech/',
    exampleTwo: 'www.facebook.com/languagelab/',
  },
  [ABOUT_COMPANY_GENERAL_NAMES.LINKEDIN]: {
    name: 'Linkedin',
    instruction: SOCIAL_NETWORKS_INSTRUCTION_TEXT,
    exampleOne: '',
    exampleTwo: '',
  },
  [ABOUT_COMPANY_GENERAL_NAMES.INSTAGRAM]: {
    name: 'Instagram',
    instruction: SOCIAL_NETWORKS_INSTRUCTION_TEXT,
    exampleOne: '',
    exampleTwo: '',
  },
  [ABOUT_COMPANY_GENERAL_NAMES.OTHER]: {
    name: 'Інші соціальні мережі',
    instruction: SOCIAL_NETWORKS_INSTRUCTION_TEXT,
    exampleOne: '',
    exampleTwo: '',
  },
  // TODO add the names here
  [ABOUT_COMPANY_GENERAL_NAMES.FIRST_NAME]: {
    name: "Ім'я",
    instruction:
      'Обов’язково вкажіть повне юридичне ім’я основної контактної особи. Перевірте написання та формат, щоб уникнути помилок.',
    exampleOne: 'Джон',
    exampleTwo: 'Сем',
  },
  [ABOUT_COMPANY_GENERAL_NAMES.LAST_NAME]: {
    name: 'Прізвище',
    instruction:
      'Обов’язково вкажіть повне юридичне прізвище основної контактної особи. Перевірте написання та формат, щоб уникнути помилок.',
    exampleOne: 'Джонсон',
    exampleTwo: 'Доу',
  },
  [ABOUT_COMPANY_GENERAL_NAMES.POSITION]: {
    name: 'Посада',
    instruction:
      'Укажіть офіційну посаду згідно з внутрішньою структурою компанії. Зазначте, чи є контактна особа власником, консультантом чи обіймає іншу позицію. Переконайтеся, що посада відповідає реальним функціям та відповідальності особи.',
    exampleOne: 'Генеральний директор, засновник',
    exampleTwo: 'Фінансовий директор',
  },
  [ABOUT_COMPANY_GENERAL_NAMES.CONTACT_PERSON_EMAIL]: {
    name: 'Email',
    instruction:
      'Точно вкажіть офіційну електронну адресу основної контактної особи.',
    exampleOne: 'ceo@agrotech.com',
    exampleTwo: 'ceo@languagelab.com',
  },
  [ABOUT_COMPANY_GENERAL_NAMES.CONTACT_PERSON_PHONE]: {
    name: 'Контактний номер телефону',
    instruction:
      'Надайте надійний контактний номер телефону основної контактної особи, включно з кодом міста/країни.',
    exampleOne: '+1 484 111 11 11',
    exampleTwo: '+1 464 111 35 93',
  },
  [ABOUT_COMPANY_GENERAL_NAMES.LIST_OF_FOUNDERS]: LIST_OF_FOUNDERS_INSTRUCTIONS,
};

const LIST_OF_KEY_EVENTS_FIELDS_INSTRUCTIONS = {
  [LIST_OF_KEY_EVENTS_FIELDS.TITLE]: {
    name: 'Ключові історичні події',
    instruction:
      'Коротко опишіть заснування бізнесу та ранні ключові етапи. Підкресліть початкові досягнення, такі як реєстрація компанії, отримання ліцензій чи розробка прототипу.',
    exampleOne:
      'У 2020 році Компанія запустила свою першу модель гусеничного трактора, що революціонізувала землеробство на складних ґрунтах завдяки кращому зчепленню та плавності руху.',
    exampleTwo:
      'У 2021 році мовна платформа запустила функцію перекладу на базі AI, що революціонізувала багатомовну комунікацію.',
  },
  [LIST_OF_KEY_EVENTS_FIELDS.DATE]: {
    name: 'Дата',
    instruction: 'Зазначте в якому році відбулась подія.',
    exampleOne: '',
    exampleTwo: '',
  },
};

const COMPANY_HISTORY_INSTRUCTIONS = {
  [ABOUT_COMPANY_HISTORY_NAMES.BUSINESS_IDEA_CONCEPTION]: {
    name: 'Походження бізнес-ідеї',
    instruction:
      'Опишіть, як виникла бізнес-ідея: обставини, виклики чи спостереження, що спровокували її появу. Розкажіть про ринкові прогалини, тренди чи особистий досвід, які вказали на можливість для бізнесу.',
    exampleOne:
      'Бізнес-ідея виникла з особистого досвіду Джона Джонсона, який зіткнувся з проблемами важких і вологих обґрунтувань, де традиційні трактори працюють неефективно. Разом з Олівером Смітом вони побачили можливість створити гусеничні трактори з кращим зчепленням та плавністю руху, орієнтовані на потреби фермерів у складних обґрунтованих умовах.',
    exampleTwo:
      'Ідея платформи з’явилася через хаотичний і несистемний характер ринку перекладацьких послуг. Клієнтам було складно знайти відповідних спеціалістів і перевірити їхню компетентність, а перекладачі ризикували неотриманням оплати за виконану роботу.',
  },
  [ABOUT_COMPANY_HISTORY_NAMES.MOTIVATION]: {
    name: 'Причина створення',
    instruction:
      'Чітко сформулюйте основну мету створення бізнесу. Опишіть мотивацію та цілі, які надихнули на реалізацію цієї ідеї, підкресліть позитивні зміни чи вплив, до яких прагнете.',
    exampleOne:
      'Компанію було створено для закриття прогалини на ринку сільськогосподарської техніки — браку спеціалізованих тракторів, здатних ефективно працювати на важких або вологих ґрунтах. Як власник ферми, Джон Джонсон усвідомив обмеження традиційних колісних тракторів у таких умовах і побачив можливість для інновацій.',

    exampleTwo:
      'Платформа поєднує перекладачів та клієнтів, пропонуючи зручність і ефективність у пошуку, замовленні та оплаті перекладацьких послуг. Усі комунікації та транзакції відбуваються безпечно в межах платформи, заповнюючи ринкову прогалину надійним і прозорим рішенням для якісних перекладів.',
  },
  [ABOUT_COMPANY_HISTORY_NAMES.EVENTS]: LIST_OF_KEY_EVENTS_FIELDS_INSTRUCTIONS,
};

const GOALS_INSTRUCTIONS = {
  [GOAL_ROW_NAMES.GOAL]: {
    name: 'Ціль',
    instruction:
      'Опишіть стратегічні цілі компанії, підкресливши коротко-, середньо- та довгострокові завдання, що узгоджені з місією та баченням. Укажіть основні напрями — розширення ринку, зростання доходів, інновації продуктів тощо. Опишіть стратегії, ініціативи та KPI, що підтримують досягнення цих цілей.',
    exampleOne:
      'Довгострокова ціль: досягти лідерства на глобальному ринку, диверсифікувавши продуктовий портфель, інвестуючи в R&D сталих агротехнологій і розширюючись на ринки, що розвиваються.',
    exampleTwo:
      'Короткострокова ціль: покращити зручність платформи завдяки новим функціям та збільшити базу користувачів через таргетовані маркетингові кампанії.',
  },
  [GOAL_ROW_NAMES.PRIORITY]: {
    name: 'Пріоритет',
    instruction: 'Стисло вкажіть пріоритет цілі, зазначивши, чи є вона високою, середньою чи низькою.',
    exampleOne: '',
    exampleTwo: '',
  },
  [GOAL_ROW_NAMES.TERMS]: {
    name: 'Строки',
    instruction: 'Стисло вкажіть термін реалізації цілі, зазначивши, чи вона довгострокова чи короткострокова.',
    exampleOne: '',
    exampleTwo: '',
  },
  [GOAL_ROW_NAMES.SCHEDULED_DATE]: {
    name: 'Запланована дата',
    instruction: 'Укажіть заплановану дату досягнення цілі, включно з місяцем і роком.',
    exampleOne: '',
    exampleTwo: '',
  },
  [GOAL_ROW_NAMES.MECHANISM_OF_ACHIEVEMENT]: {
    name: 'Механізм досягнення',
    instruction:
      'Опишіть механізми та стратегії, за допомогою яких ви досягатимете бізнес-цілей. Розкажіть про конкретні ініціативи, плани дій або операційні підходи, які впроваджуються для реалізації кожної цілі.',
    exampleOne:
      'Диверсифікувати продуктовий портфель, інвестувати в R&D сталих агротехнологій та виходити на ринки, що розвиваються, забезпечуючи довгострокове зростання й конкурентоспроможність.',
    exampleTwo:
      'Запровадити цикл збирання зворотного зв’язку користувачів для пріоритизації функцій, регулярно випускати інтуїтивні оновлення. Реалізувати таргетовані маркетингові кампанії в цифрових каналах для залучення та утримання нових користувачів.',
  },
};

const MISSION_NAMES_INSTRUCTIONS = {
  [ABOUT_COMPANY_MISSION_NAMES.VISION_OF_FUTURE]: {
    name: 'Бачення',
    instruction:
      'Сформулюйте довгострокове бачення, що визначає майбутнє компанії. Підкресліть трансформаційний вплив на галузь або спільноту. Чітко опишіть бажані результати та роль компанії в їх досягненні. Узгодьте бачення з цінностями та сутністю компанії.',
    exampleOne:
      'Бачення Компанії — очолити аграрну індустрію в напрямку технологічно розвиненого майбутнього, де інноваційні тракторні рішення стануть рушієм підвищення продуктивності, екологічної відповідальності та економічного добробуту в усьому світі.',
    exampleTwo:
      'Бачення Компанії — стати лідером у сфері мовних послуг завдяки інноваційним технологіям та етичним практикам, сприяючи глобальній взаємодії.',
  },
  [ABOUT_COMPANY_MISSION_NAMES.CORE_VALUES]: {
    name: 'Цінності компанії',
    instruction:
      'Опишіть ключові цінності компанії. Визначте базові принципи, які формують організаційну культуру. Поясніть, як вони узгоджуються з місією та ідентичністю компанії та як допомагають формувати етичну поведінку співробітників і позитивне робоче середовище.',
    exampleOne:
      'Ключові цінності компанії — інноваційність, цілісність та сталість, які визначають усі рішення й сприяють культурі відповідальності та прагнення до досконалості.',
    exampleTwo:
      'Мовна платформа цінує інклюзивність, точність і орієнтованість на користувача, забезпечуючи доступні та надійні комунікаційні рішення для всіх.',
  },
  [ABOUT_COMPANY_MISSION_NAMES.PROBLEM_OF_MARKET]: {
    name: 'Визначення проблеми',
    instruction:
      'Коротко опишіть ринковий контекст і конкретну проблему чи потребу. Сформулюйте ключові виклики галузі та їхній вплив на стейкхолдерів. Визначте ринкові прогалини, які створюють можливість для вашого бізнесу.',
    exampleOne:
      'Звичайні колісні трактори мають низьку ефективність на важких або вологих ґрунтах, що призводить до зниження зчеплення, пробуксовки та ущільнення ґрунту. Це зменшує продуктивність фермерських господарств, ускладнює посів, обробіток і збирання урожаю, знижує врожайність та підвищує операційні витрати.',
    exampleTwo:
      'Індустрія мовних послуг страждає від неефективних процесів, що спричиняє затримки та збої в комунікації. Клієнтам складно знайти відповідних перекладачів, а перекладачам — просувати свої послуги та перевіряти надійність клієнтів. Потрібна надійна платформа для спрощення співпраці та посилення довіри в глобальному бізнесі.',
  },
  [ABOUT_COMPANY_MISSION_NAMES.HOW_PROJECT_ADDRESSES_THE_PROBLEM]: {
    name: 'Внесок у розв’язання проблеми',
    instruction:
      'Опишіть предмет бізнес-плану, підкресліть унікальні елементи рішення. Окресліть ключові функції, зробивши акцент на тому, як саме вони розв’язують проблему. Розкрийте стратегічний підхід, включно з інноваційними технологіями чи ціннісними пропозиціями. Сформулюйте вигоди та результати для стейкхолдерів.',
    exampleOne:
      'Бізнес-план зосереджений на розробці спеціалізованих гусеничних тракторів із запатентованою технологією безперервних гусениць, що вирішують проблеми продуктивності на важких ґрунтах. Ці трактори мають збільшений строк служби й економічно вигідні, знижуючи операційні витрати та підвищуючи прибутковість для фермерів.',
    exampleTwo:
      'Компанія вирішує проблему децентралізації ринку перекладацьких послуг через централізовану платформу з ретельним відбором виконавців, безпечними платежами та технологіями на базі AI. Стратегія компанії спирається на технології для оптимізації процесів, покращення комунікації, ефективності та довіри між клієнтами й перекладачами.',
  },
  [ABOUT_COMPANY_MISSION_NAMES.GOALS]: GOALS_INSTRUCTIONS,
};

const SWOT_OPPORTUNITIES_INSTRUCTIONS = {
  [SWOT_ROW_NAMES.TITLE]: {
    name: 'Можливості',
    instruction:
      'Проаналізуйте ринкові тренди та визначте можливості, які відповідають сильним сторонам компанії. Опишіть зміни в поведінці споживачів, технологічний прогрес і регуляторні тенденції. Розгляньте, як використати ці тренди для розширення ринку, запуску нових продуктів або виходу на нові сегменти.',
    exampleOne: ul([
      'Вихід на ринки, що розвиваються, із зростаючим попитом на спеціалізовану сільськогосподарську техніку.',
      'Диверсифікація продуктового портфеля за рахунок додаткового обладнання та аксесуарів для гусеничних тракторів.',
      'Партнерства з аграрними науково-дослідними установами чи університетами для спільного розвитку технологій управління ґрунтом та методів ведення господарства.',
    ]),
    exampleTwo: ul([
      'Додавання функцій усного та синхронного перекладу.',
      'Використання досягнень AI і машинного навчання для подальшого вдосконалення платформи та підвищення точності перекладів.',
      'Вихід на нові міжнародні ринки зростаючого попиту на перекладацькі послуги.',
    ]),
  },
};

const SWOT_THREATS_INSTRUCTIONS = {
  [SWOT_ROW_NAMES.TITLE]: {
    name: 'Загрози',
    instruction:
      'Визначте та проаналізуйте зовнішні загрози: ринкові тренди, конкуренцію, економічні спади, регуляторну невизначеність. Опишіть їхній вплив на операційну діяльність, частку ринку та взаємовідносини з клієнтами. Сформулюйте потенційні негативні наслідки та вразливості.',
    exampleOne: ul([
      'Посилення конкуренції з боку великих, усталених виробників із більш значними ресурсами та часткою ринку.',
      'Регуляторні зміни або екологічні норми, що впливають на використання сільськогосподарської техніки чи гумових матеріалів.',
      'Технологічні прориви конкурентів, які призводять до появи альтернативних рішень для роботи на складних ґрунтах.',
    ]),
    exampleTwo: ul([
      'Потенційна вразливість до кіберзагроз або витоків даних через залежність від цифрових платформ.',
      'Економічні спади або коливання валютних курсів, що впливають на витрати клієнтів на перекладацькі послуги.',
      'Поява нових конкурентів або проривних технологій, що загрожують частці ринку та диференціації компанії.',
    ]),
  },
};

const SWOT_INSTRUCTIONS = {
  [ABOUT_COMPANY_SWOT_NAMES.OPPORTUNITIES]: SWOT_OPPORTUNITIES_INSTRUCTIONS,
  [ABOUT_COMPANY_SWOT_NAMES.THREATS]: SWOT_THREATS_INSTRUCTIONS,
};

export const ABOUT_COMPANY_INSTRUCTIONS = {
  [BUSINESS_TOOL_SUB_SECTIONS.ABOUT_COMPANY.GENERAL_INFO]: GENERAL_INFO_INSTRUCTIONS,
  [BUSINESS_TOOL_SUB_SECTIONS.ABOUT_COMPANY.COMPANY_HISTORY]: COMPANY_HISTORY_INSTRUCTIONS,
  [BUSINESS_TOOL_SUB_SECTIONS.ABOUT_COMPANY.MISSION_AND_STRATEGY]: MISSION_NAMES_INSTRUCTIONS,
  [BUSINESS_TOOL_SUB_SECTIONS.ABOUT_COMPANY.SWOT]: SWOT_INSTRUCTIONS,
};
